<template>
  <div>
    <div class="container">
      <div class="screen">
        <div class="screen__content">
          <form class="login">
            <div class="login__field">
              <a-icon type="user" />
              <input v-model="user" type="text" class="login__input" placeholder="User" />
            </div>
            <span v-if="userShow" class=" text-red-600">必填</span>
            <div class="login__field">
              <a-icon type="lock" />
              <input v-model="password" type="password" class="login__input" placeholder="Password" />
            </div>
            <span v-if="passwordShow" class=" text-red-600">必填</span>
            <button @click="LogIn()" class="button login__submit">
              <span class="button__text">Log In</span>
            </button>
          </form>
        </div>
        <div class="screen__background">
          <span class="screen__background__shape screen__background__shape4"></span>
          <span class="screen__background__shape screen__background__shape3"></span>
          <span class="screen__background__shape screen__background__shape2"></span>
          <span class="screen__background__shape screen__background__shape1"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activeAppVariant } from '../appVariant'

export default {
  name: 'LogIn',

  data () {
    return {
      // API 路徑配置
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,

      user: null,
      password: null,
      userShow: false,
      passwordShow: false
    }
  },

  mounted () {},

  methods: {
    LogIn () {
      // 表單驗證
      if (!this.user) {
        this.userShow = true
        return
      } else {
        this.userShow = false
      }
      if (!this.password) {
        this.passwordShow = true
        return
      } else {
        this.passwordShow = false
      }

      // 🆕 真實的登入 API 呼叫
      this.performLogin()
    },

    async performLogin () {
      try {
        console.log('🔐 開始登入驗證...')
        const response = await this.axios.post(
          `${this.baseURL}${this.basePort}/auth/login`,
          {
            account: this.user,
            password: this.password
          }
        )
        console.log('✅ 登入API回應:', response.data)
        if (response.data.message === 'success') {
          const token = response.data.data.token
          const userInfo = response.data.data.user || { account: this.user }

          // 🆕 使用 Vuex 儲存登入狀態
          this.$store.dispatch('login', {
            token: token,
            user: userInfo
          })
          console.log('🚀 登入成功，準備跳轉...')
          this.$router.push({ path: activeAppVariant.defaultAuthenticatedRoute })
          // 顯示成功訊息
          this.$message.success('登入成功！')
        } else {
          throw new Error(response.data.errorMsg || '登入失敗')
        }
      } catch (error) {
        console.error('❌ 登入失敗:', error)

        let errorMessage = '登入失敗'
        if (error.response && error.response.data) {
          errorMessage = error.response.data.errorMsg || error.response.data.message || errorMessage
        } else if (error.message) {
          errorMessage = error.message
        }

        this.$message.error(errorMessage)

        // 清空密碼欄位
        this.password = null
      }
    },

    // 🆕 登出方法（可在其他頁面使用）
    async logout () {
      try {
        // 呼叫登出 API
        await this.axios.post(`${this.baseURL}${this.basePort}/user/logout`)

        // 清除本地登入狀態
        this.$store.dispatch('logout')
        // 跳轉到登入頁
        this.$router.push({ path: '/LogIn' })
        this.$message.success('登出成功！')
      } catch (error) {
        console.error('登出API失敗，但仍清除本地狀態:', error)
        // 即使API失敗也要清除本地狀態
        this.$store.dispatch('logout')
        this.$router.push({ path: '/LogIn' })
      }
    }
  }
}
</script>

<style lang="css" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:400,700");

* {
  font-family: Raleway, sans-serif;
}

body {
  background: linear-gradient(90deg, #c7c5f4, #776bcc);
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  /* min-height: 100vh; */
}

.screen {
  background: linear-gradient(90deg, #4d9fec, #53a9ef);
  position: relative;
  height: 600px;
  width: 360px;
  box-shadow: 0px 0px 24px #4f95ea;
}

.screen__content {
  z-index: 1;
  position: relative;
  height: 100%;
}

.screen__background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  -webkit-clip-path: inset(0 0 0 0);
  clip-path: inset(0 0 0 0);
  overflow: hidden;
}

.screen__background__shape {
  transform: rotate(45deg);
  position: absolute;
}

.screen__background__shape1 {
  height: 520px;
  width: 520px;
  background: #fff;
  top: -50px;
  right: 120px;
  border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
  height: 220px;
  width: 220px;
  background: #6c63ac;
  top: -172px;
  right: 0;
  border-radius: 32px;
}

.screen__background__shape3 {
  height: 540px;
  width: 190px;
  background: linear-gradient(270deg, #5d54a4, #6a679e);
  top: -24px;
  right: 0;
  border-radius: 32px;
}

.screen__background__shape4 {
  height: 400px;
  width: 200px;
  background: #5d54a4;
  top: 420px;
  right: 50px;
  border-radius: 60px;
}

.login {
  width: 320px;
  padding: 30px;
  padding-top: 156px;
}

.login__field {
  padding: 15px 0px;
  position: relative;
}

.login__icon {
  position: absolute;
  top: 30px;
  color: #7875b5;
}

.login__input {
  border: none;
  border-bottom: 2px solid #d1d1d4;
  background: none;
  padding: 10px;
  padding-left: 24px;
  font-weight: 700;
  width: 75%;
  transition: 0.2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
  outline: none;
  border-bottom-color: #6a679e;
}

.login__submit {
  background: #fff;
  font-size: 14px;
  margin-top: 30px;
  padding: 16px 20px;
  border-radius: 26px;
  border: 1px solid #d4d3e8;
  text-transform: uppercase;
  font-weight: 700;
  display: flex;
  align-items: center;
  width: 100%;
  color: #4c489d;
  box-shadow: 0px 2px 2px #5c5696;
  cursor: pointer;
  transition: 0.2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
  border-color: #6a679e;
  outline: none;
}

.button__icon {
  font-size: 24px;
  margin-left: auto;
  color: #7875b5;
}
</style>
